<template>
  <section class="w-full px-6 py-4 bg-white rounded-lg">
    <h2 class="text-xl text-green-700 font-medium mb-4">
      Anggota Tim Anda
    </h2>
    <div class="min-w-0 w-full flex gap-4 mb-5 items-center">
      <SearchBar
        placeholder="Cari anggota"
        @input="onSearch($event)"
      />
      <JdsSelect
        placeholder="Semua Anggota"
        v-model="params.role"
        :options="roleOptions"
      />
      <JdsSelect
        placeholder="Semua Status"
        v-model="params.status"
        :options="statusOptions"
      />
      <BaseButton
        class="bg-green-700 hover:bg-green-600"
        @click="submitFilter"
      >
        <span class="w-full text-sm font-normal text-white text-center">
          Terapkan Filter
        </span>
      </BaseButton>
      <BaseButton
        class="border-transparent hover:bg-green-50"
        @click="clearFilter"
      >
        <span class="font-normal text-sm text-green-700">
          Reset Filter
        </span>
      </BaseButton>
    </div>
    <div class="w-full overflow-auto">
      <MemberTable
        :items="items"
        :loading="loading"
        :meta="meta"
        class="min-w-[1000px]"
        @success:action="onSuccess"
        @update:pagination="onUpdatePagination($event)"
      />
    </div>
  </section>
</template>

<script>
import BaseButton from '@/common/components/BaseButton';
import MemberTable from '@/components/Settings/Member/ListSection/MemberTable';
import SearchBar from '@/common/components/SearchBar';
import { formatDate } from '@/common/helpers/date.js';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const userRepository = RepositoryFactory.get('user');

const DEFAULT_PARAMS = {
  per_page: 10,
  page: 1,
  q: '',
  role: '',
  status: '',
  unit_name: '',
};

export default {
  name: 'MemberListSection',
  components: {
    BaseButton,
    MemberTable,
    SearchBar,
  },
  data() {
    return {
      loading: false,
      members: [],
      meta: {
        total_count: 3,
        total_page: 1,
        current_page: 1,
        per_page: 10,
      },
      params: { ...DEFAULT_PARAMS },
      roleOptions: [
        { label: 'Semua Anggota', value: '' },
        { label: 'Super Admin', value: 'Super Admin' },
        { label: 'Group Admin', value: 'Group Admin' },
        { label: 'Admin', value: 'Admin' },
        { label: 'Contributor', value: 'Contributor' },
      ],
      statusOptions: [
        { label: 'Semua Status', value: '' },
        { label: 'Aktif', value: 'ACTIVE' },
        { label: 'Tidak Aktif', value: 'INACTIVE' },
        { label: 'Pending', value: 'PENDING' },
        { label: 'Lupa Password', value: 'FORGOT_PASSWORD' },
      ],
    };
  },
  computed: {
    items() {
      if (Array.isArray(this.members) && !!this.members.length) {
        return this.members.map((member) => ({
          ...member,
          last_active: member.last_active ? formatDate(member.last_active, 'dd/MM/yyyy - HH:mm') : null,
        }));
      }

      return [];
    },
  },
  activated() {
    this.fetchMembers();
  },
  methods: {
    async fetchMembers() {
      try {
        this.loading = true;

        const response = await userRepository.getMemberList(this.params);
        const { data, meta } = response.data;

        this.members = data;
        this.meta = meta;
      } catch (error) {
        this.$toast({
          type: 'error',
          message: 'Gagal mendapatkan data Member, silakan coba beberapa saat lagi',
        });
      } finally {
        this.loading = false;
      }
    },

    setParams(data) {
      this.params = { ...this.params, ...data };
    },

    onUpdatePagination(data) {
      this.setParams(data);
      this.fetchMembers();
    },
    onSuccess() {
      this.fetchMembers();
    },
    onSearch(query) {
      this.setParams({ q: query, page: 1 });
      this.fetchMembers();
    },
    submitFilter() {
      this.setParams({ page: 1 });
      this.fetchMembers();
    },
    clearFilter() {
      this.params = { ...DEFAULT_PARAMS };
      this.fetchMembers();
    },
  },
};
</script>
